import axios from "@api/axiosInstance";
import { useQuery } from "@tanstack/react-query";
import { UnmappedCadMaterialsClient, UnMappedCadMaterialsResponse } from "./apiClient";

const unmappedCadMaterialsClient = new UnmappedCadMaterialsClient(undefined, axios);

export const useUnmappedCadMaterials = (profileId: string | null | undefined, options?: any) => {
  return useQuery<UnMappedCadMaterialsResponse[]>({
    ...options,
    queryKey: ["unmappedCadMaterials", profileId],
    queryFn: async () => unmappedCadMaterialsClient.getUnMappedCadMaterials(profileId),
  });
};
